import { ThemeOptions } from '@mui/material';

export const MuiIconButton: ThemeOptions['components']['MuiIconButton'] = {
  defaultProps: { disableFocusRipple: true },
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-focusVisible, &:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main}`,
        outlineOffset: 2,
        backgroundColor: theme.palette.action.hover
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      },
      '& .Mui-disabled': {
        color: theme.palette.text.disabled
      }
    }),
    sizeSmall: {
      padding: '4px',
      fontSize: '1rem'
    },
    sizeMedium: {
      padding: '6px',
      fontSize: '1.25rem'
    },
    sizeLarge: {
      padding: '8px',
      fontSize: '1.5rem'
    }
  }
};
